import * as React from 'react'
import { FormattedMessage } from 'react-intl'
import { PriceExplanationMark } from '@components/PriceInfo/PriceExplanationMark'
import { getPriceOrNull } from '../../helpers'
import { useBookingFormStore } from '../../providers/BookingFormStoreProvider'
import { IPrice } from '../../store/data'
import DiscountedPrice from '../DiscountedPrice'
import Typography from '../Typography'
import styles from './LowestPrice.module.scss'

type LowestPriceProps = {
  data: IPrice | null
  withPriceExplanation?: boolean
}

const LowestPrice: React.FunctionComponent<LowestPriceProps> = ({
  data,
  withPriceExplanation = false,
}) => {
  const language = useBookingFormStore((state) => state.language)
  const amountPerNight = data ? getPriceOrNull(data, 'amount_per_night', language) : null
  const originalPerNight = data
    ? getPriceOrNull(data, 'original_amount_per_night', language)
    : null

  return (
    <div className={styles.root}>
      <Typography className={styles.rootPrice} component="div" variant="category">
        <span className="mr-2">
          <FormattedMessage
            defaultMessage="from"
            description="From price on Lowest price component"
          />
        </span>
        {amountPerNight !== null ? (
          <>
            <DiscountedPrice original={originalPerNight} value={amountPerNight} />
            {withPriceExplanation && <PriceExplanationMark />}
          </>
        ) : (
          '-'
        )}
      </Typography>
      <Typography className={styles.rootDescription} component="span">
        <FormattedMessage
          defaultMessage="night"
          description="night unit in Lowest price component"
        />
      </Typography>
    </div>
  )
}

export default LowestPrice
